// File: CustomerOrderTypePage.jsx
import React, { useRef } from 'react';
import { Toast } from 'primereact/toast';
import WaybillShipmentTypeTable from './components/WaybillShipmentTable';
import waybillShipment from './hooks/useWaybillShipment';
import WaybillShipmentTypeFilter from './components/WaybillShipmentTypeFilter';
import { useLanguage } from '../../../contexts/LanguageContext';

const WaybillShipmentPage = () => {
    const { th } = useLanguage();

    const {
        toast,
        tableProps,
        filterFields,
        customFilterTypes,
        customFilterOptions,
        handleSearch,
        handleResetFilters,
        handleApplyFilters,
    } = waybillShipment();



    const columnsRef = useRef(null);

    return (
        <div className="card">
            <Toast ref={toast} />
            {console.log("tableProps", tableProps)}

            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('parts.waybillShipment')}</h1>
            </div>

            <WaybillShipmentTypeFilter
                filterFields={filterFields}
                columns={columnsRef.current}
                customFilterTypes={customFilterTypes}
                customFilterOptions={customFilterOptions}
                handleSearch={handleSearch}
                handleApplyFilters={handleApplyFilters}
                handleResetFilters={handleResetFilters}
            />


            <WaybillShipmentTypeTable {...tableProps} />
        </div>
    );
};

export default WaybillShipmentPage;
